import Member from './member';
import Brand from '@/modules/brand/brand';
import BrandClass from './brand';

export default class League {
  id: number;
  name: string;
  description: string;
  isPrivate: Boolean = false;
  isOfficial: Boolean = false;
  isFirestone: Boolean = false;
  password: string;
  seasonId: number;
  isAdmin: Boolean = false;
  members: Array<Member>;
  rank: number;
  brandId: number;
  brand: BrandClass;
  isMember: Boolean;
  isPermanent: Boolean;
  constructor(starter?: any) {
    starter = starter || {};
    // Deal with 0 Id's
    this.id = starter.id !== null && !isNaN(starter.id) ? starter.id : null;
    this.name = starter.name || null;
    this.description = starter.description || null;
    this.isPrivate = starter.isPrivate || false;
    this.isOfficial = starter.isOfficial || false;
    this.isFirestone = starter.isFirestone || false;
    this.password = starter.password || null;
    this.seasonId = starter.seasonId || null;
    this.rank = starter.rank || 0;
    this.isAdmin = starter.isAdmin || false;
    this.isMember = starter.isMember || false;
    this.isPermanent = starter.isPermanent || false;
    this.brandId = starter.brandId || 0;
    this.brand = Brand.byId(starter.brandId);
    this.members = starter.members || [];
    this.members = this.members.map((member: any) => {
      return new Member(member);
    });
  }
}
